import { render, staticRenderFns } from "./IdeaBox.vue?vue&type=template&id=64a97019&scoped=true&"
import script from "./IdeaBox.vue?vue&type=script&lang=js&"
export * from "./IdeaBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a97019",
  null
  
)

export default component.exports